import axios from '@/utils/axios';
import type { AuthSession } from '@/features/users/shared/types';

type GetAuthSessionsResponse = {
  data?: AuthSession[];
};

export async function getAuthSessions(
  userId: string | number
): Promise<AuthSession[]> {
  const response = await axios.get<GetAuthSessionsResponse>('/auth/sessions', {
    params: { userId },
  });
  return response.data?.data ?? [];
}

export async function deleteAuthSession(
  sessionId: string,
  userId: string | number
): Promise<void> {
  await axios.delete(`/auth/sessions/${sessionId}`, {
    params: { userId },
  });
}

export async function revokeAllAuthSessions(
  userId: string | number
): Promise<void> {
  await axios.delete('/auth/sessions', {
    params: { userId },
  });
}
